import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  opened: boolean;
  mobile: boolean;
  constructor() { }

  ngOnInit() {
  }

  open() {
    this.opened = true;
  }

  close() {
    this.opened = false;
  }
}
